export default "__VITE_ASSET__egtE8oFY__"